<div *ngIf="cart; else empty"
     [appClickableBlock]="cart"
     [class]="cart.uId"
     [item]="cart"
     app-block>
</div>

<ng-template #empty>
  <div>Missing view part <span>'cartToggle'</span></div>
</ng-template>
